<template>
  <div class="item__icon">
    <fa v-if="icon" :icon="icon" :size="size" />
  </div>
</template>

<script setup lang="ts">
  const props = defineProps<{
    contentType: string;
    size?: string;
  }>();

  const iconMap: Record<string, [string, string]> = {
    journals: ["fas", "pencil"],
    blog: ["fas", "blog"],
    "reports-and-white-papers": ["fas", "check-square"],
    "book-reviews": ["fas", "book"],
    "tools-templates-checklists": ["fas", "check-square"],
    videos: ["fas", "video"],
    "how-guides": ["fas", "check-square"],
    webinars: ["fas", "video"],
    infographics: ["fas", "images"],
    email: ["fas", "envelope"],
    twitter: ["fab", "twitter-square"],
    facebook: ["fab", "facebook-square"],
    linkedin: ["fab", "linkedin"],
    tick: ["fas", "check"],
    cross: ["fas", "times"],
    // Additional icons from your Nuxt 2 config
    "list-view": ["fas", "list-ul"],
    "gallery-view": ["fas", "th-large"],
    "my-account": ["fas", "user-circle"],
    "locked-file": ["fas", "lock"],
    search: ["fas", "search"],
    "search-error": ["fas", "sad-tear"],
    "chevron-down": ["fas", "chevron-down"],
    copy: ["fas", "copy"],
    star: ["fas", "star"]
  };

  const icon = iconMap[props.contentType] || ["fas", "images"]; // Default to images icon
</script>
